/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popBindWallet.vue?vue&type=template&id=71f73998"
import script from "./popBindWallet.vue?vue&type=script&lang=js"
export * from "./popBindWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports